export default __webpack_public_path__ + "static/media/windows-icon.4949b046.svg";